<template>
  <LicenseAgreementBY v-if="locale.currentCountry === COUNTRY_CODE.BY" />
  <LicenseAgreementCIS v-else-if="locale.currentCountry !== COUNTRY_CODE.RU" />
  <LicenseAgreementRU v-else />
</template>

<script setup lang="ts">
import { COUNTRY_CODE } from '~/core/i18n'
import { generatePageMetaLinks } from '~/core/seo'
import LicenseAgreementRU from '~/features/license-agreement/LicenseAgreementRU.vue'
import LicenseAgreementBY from '~/features/license-agreement/LicenseAgreementBY.vue'
import LicenseAgreementCIS from '~/features/license-agreement/LicenseAgreementCIS.vue'

definePageMeta({
  layout: 'sidebar',
})

const locale = useAppLocale()

useHead({
  link: generatePageMetaLinks(),
})
</script>
